import React from 'react';
import PropTypes from 'prop-types';
import {
    CardContainer,
    HeaderContainer,
    RevenueText,
    IconWrapper,
    ContentContainer,
    RevenueAmountContainer,
    RevenueAmount,
    TotalRevenueText,
    TotalEarnedContainer,
    TotalEarnedText,
    TotalEarnedAmount,
    TotalIcon,
} from './RevenueCard.styles';

const RevenueCard = ({ totalRevenue, lastEarned, currency = 'AUD' }) => {
    const formattedRevenue = totalRevenue.toFixed(2); // 確保有兩位小數
    const [integerPart, decimalPart] = formattedRevenue.split('.'); // 分割小數點前後的部分
    const formattedIntegerPart = parseInt(integerPart, 10).toLocaleString();
    const formatCurrencySymbol = (currency) => {
        switch (currency) {
            case 'AUD': return '$';
            case 'GBP': return '£';
            case 'USD': return '$';
            case 'EUR': return '€';
            default: return '$';
        }
    };

    const formattedLastEarned = `${lastEarned >= 0 ? '+' : '-'}${formatCurrencySymbol(currency)}${Math.abs(lastEarned).toLocaleString()}`;



    return (
        <CardContainer>
            <HeaderContainer>
                <div>
                    <RevenueText>My Revenue</RevenueText>
                    <TotalRevenueText>* Revenue figures are for reference only * </TotalRevenueText>
                </div>
                <IconWrapper />
            </HeaderContainer>
            <ContentContainer>
                <RevenueAmountContainer>
                    <TotalRevenueText>Total revenue</TotalRevenueText>
                    <RevenueAmount>
                        {formatCurrencySymbol(currency)}{formattedIntegerPart}
                        <span className="decimal">.{decimalPart}</span>
                    </RevenueAmount>

                </RevenueAmountContainer>
                <TotalEarnedContainer>
                    <TotalIcon></TotalIcon>
                    <TotalEarnedText>Compared to Last Month</TotalEarnedText>
                    <TotalEarnedAmount>{formattedLastEarned}</TotalEarnedAmount>
                </TotalEarnedContainer>
            </ContentContainer>
        </CardContainer>
    );
};

RevenueCard.propTypes = {
    totalRevenue: PropTypes.number.isRequired,
    lastEarned: PropTypes.number.isRequired,
};

export default RevenueCard;
